import script from "./InpuText.vue?vue&type=script&setup=true&lang=js"
export * from "./InpuText.vue?vue&type=script&setup=true&lang=js"

import "./InpuText.vue?vue&type=style&index=0&id=107053cc&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-107053cc"]])

export default __exports__